import * as _ from 'lodash-es';

/**
 * Function that returns concatenated value for data-link-event attribute
 * @param prefix
 * @param value
 */
function formatDataLinkEvent(prefix, value) {
    if (!prefix) {
        return '';
    }
    const _dataLinkEvent = value ? `${prefix.trim()} | ${value}` : prefix;
    return _dataLinkEvent.trim();
}
/**
 * Function that returns value for data-link-event attribute
 * @param dataLinkEvent
 * @param key
 */
const getDataLinkEvent = (dataLinkEvent, key) => {
    if (_.isEmpty(dataLinkEvent)) {
        return '';
    }
    return dataLinkEvent[key] ?? '';
};

export { formatDataLinkEvent as f, getDataLinkEvent as g };
